import * as React from 'react';

function PlaceholderCardIcon({ 'aria-hidden': ariaHidden = true, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={ariaHidden} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 3C14 1.34315 12.6569 0 11 0H3C1.34315 0 0 1.34315 0 3V17C0 18.6569 1.34315 20 3 20H11C12.6569 20 14 18.6569 14 17V3ZM6 7.11111C6 3.03809 10.2123 1.65972 13 4.49387V15.629C13 15.629 6 11.1842 6 7.11111Z"
        fill="#383C52"
      />
      <mask
        id="mask0_1887_2437"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="14"
        height="20"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14 3C14 1.34315 12.6569 0 11 0H3C1.34315 0 0 1.34315 0 3V17C0 18.6569 1.34315 20 3 20H11C12.6569 20 14 18.6569 14 17V3ZM6 7.11111C6 3.03809 10.2123 1.65972 13 4.49387V15.629C13 15.629 6 11.1842 6 7.11111Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1887_2437)">
        <rect x="-5" y="-2" width="24" height="24" fill="#383C52" />
      </g>
    </svg>
  );
}

export default PlaceholderCardIcon;
